import { getAvatarColorsForString } from "@/shared/utils/avatarColors";
import { cn } from "@/lib/utils";

type UserAvatarProps = {
  /** Display name used for initial and for deterministic color (same name = same color). */
  name: string;
  /** Optional size: "sm" | "md" | "lg". Default "md". */
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeClasses = {
  sm: "h-10 w-10 text-sm",
  md: "h-14 w-14 text-lg",
  lg: "h-16 w-16 text-xl",
};

export function UserAvatar({ name, size = "md", className }: UserAvatarProps) {
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  const colors = getAvatarColorsForString(name);

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full border-2 font-bold",
        colors.bg,
        colors.border,
        colors.text,
        sizeClasses[size],
        className
      )}
      aria-hidden
    >
      {initial}
    </div>
  );
}
